import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AUTH_ENDPOINTS } from "../../../config/constants";

const ProfileSection = ({
  user,
  profile,
  setProfile,
  profileMessage,
  onSave,
}) => {
  const { t } = useTranslation();
  const [hasChanges, setHasChanges] = useState(false);
  const [initialProfile, setInitialProfile] = useState(profile);

  useEffect(() => {
    // Update initial profile when vehicle data changes
    setInitialProfile(profile);
  }, []); // Empty dependency array means this only runs once on mount

  useEffect(() => {
    setHasChanges(profile !== initialProfile);
  }, [profile, initialProfile]);

  const handleSave = () => {
    onSave();
    setInitialProfile(profile);
  };

  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-base font-semibold">
          {t("vehicleProfile.profile.title")}
        </h3>
        {!user && (
          <p className="text-xs text-gray-600">
            <a
              href={`${
                AUTH_ENDPOINTS.GOOGLE_LOGIN
              }?returnTo=${encodeURIComponent(
                window.location.pathname + window.location.search
              )}`}
              className="text-blue-500 hover:text-blue-600 transition-colors"
              onClick={(e) => {
                const returnPath =
                  window.location.pathname + window.location.search;
                sessionStorage.setItem("preLoginPath", returnPath);
                localStorage.setItem("preLoginPath", returnPath);
              }}
            >
              {t("vehicleProfile.profile.loginToEdit")}
            </a>
          </p>
        )}
      </div>
      <textarea
        className="w-full bg-white border rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm dark:bg-gray-800 dark:text-gray-400 dark:border-gray-700 dark:focus:ring-blue-500 dark:focus:border-blue-500"
        value={profile}
        onChange={(e) => setProfile(e.target.value)}
        rows={profile ? Math.max(profile.split("\n").length, 4) + 1 : 4}
        disabled={!user}
        placeholder={t("vehicleProfile.profile.placeholder")}
      />
      {user && hasChanges && (
        <div className="mt-3 flex justify-end">
          <button
            className="px-4 py-1.5 bg-gradient-to-r from-primary-600 to-primary-700 text-white rounded-md hover:from-primary-700 hover:to-primary-800 active:from-primary-800 active:to-primary-900 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:ring-offset-2 text-sm"
            onClick={handleSave}
          >
            {t("vehicleProfile.profile.saveProfile")}
          </button>
        </div>
      )}
      {profileMessage && (
        <div
          className={`mt-3 p-2 rounded-md text-sm dark:text-gray-400 ${
            profileMessage.type === "error"
              ? "bg-red-50 text-red-700 dark:bg-red-900 dark:text-red-100"
              : "bg-green-50 text-green-700 dark:bg-green-900 dark:text-green-100"
          }`}
        >
          {profileMessage.text}
        </div>
      )}
    </div>
  );
};

export default ProfileSection;
